<mat-progress-spinner mode="indeterminate" style="margin: 0 auto" *ngIf="!error"></mat-progress-spinner>

<div *ngIf="error" style="text-align: center; font-size: 20px">
  <h3>Ошибка</h3>
  <span style="color: #b40000">
    {{error}}
  </span>
</div>
